export default __webpack_public_path__ + "media/images/icons_fc/user_support-61d2e5d1725e028a1952eb56a62664f4.png";